/** 権限の列挙型定義 */
export enum OPERATION_PERMISSIONS {
  COMPANY_SETTING_MATCHING_WRITE = 'company_setting_matching_write',
  COMPANY_SETTING_COMPANY_WRITE = 'company_setting_company_write',
  COMPANY_MATCHING_READ = 'company_matching_read'
}
